import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, min } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { AdService } from '../ad/ad.service';
import { Main } from '../core/main.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { environment } from '@env/environment';

@Component({
  selector: 'cp-clients',
  templateUrl: './clients.component.html',
})

export class ClientsComponent {

  client: any;
  option: any;
  file: any;
  isLoading: any;
  id: string;
  clientForm!: FormGroup;
  config: any;
  operation: string;

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  clients: any[];
  awards: any[];
  ekubMembers: any[];
  selectedAward: number = 0;
  selectedAwd: any = {};
  selectedSeller: any = {};


  files: File[] = [];
  files_temp: any[];
  localUrl: any;
  /*   localCompressedURl: any;
    sizeOfOriginalImage: number;
    sizeOFCompressedImage: number;
    imgResultBeforeCompress: string;
    imgResultAfterCompress: string; */
  uploadResponse = { status: '', message: '', filePath: '' };
  uploading = false;
  successUploadCount = 0;
  failedUploadCount = 0;
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private imageCompress: NgxImageCompressService, private coreService: CoreService, private api: AdService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.client = {
      'title': '',
      'position': 0,
      'remark': ''
    };
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      //this.getClient();
    }
    this.operation = 'add';
    this.option = {
      width: '200',
      tags: true
    };
    this.files = [];
    this.files_temp = [];
  }

  get trade_name() { return this.clientForm.get('trade_name'); }
  get business_category() { return this.clientForm.get('business_category'); }
  get registration_date() { return this.clientForm.get('registration_date'); }
  get tin_number() { return this.clientForm.get('tin_number'); }
  get type() { return this.clientForm.get('type'); }
  get status() { return this.clientForm.get('status'); }
  get remark() { return this.clientForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getClients();
  }



  getClients() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getClients(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.clients = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {
    debugger;
    this.clientForm = this.formBuilder.group({
      trade_name: ['', [Validators.required,]],
      business_category: ['', [Validators.required]],
      registration_date: ['',],
      tin_number: [''],
      type: [''],
      status: ['', [Validators.required]],
      remark: [''],
    });
  }

  getEkubMembers(ekubId: any) {
    debugger;
    this.api.getClientAds(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        if (this.selectedAwd) {
          var index = this.ekubMembers.map(x => {
            return x.id;
          }).indexOf(this.selectedAwd.winner.data.id);
          this.ekubMembers.splice(index, 1);
        }
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }

  changeStatus(clients: any, status: any) {
    debugger;
    this.api.changeClientStatus(clients.id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getClients();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  getClient() {
    this.api.getClient(this.id).subscribe((res: any) => {
      debugger;
      this.client = res.data;
      this.clientForm.setValue(res.data);
    });
  }


  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  addClient() {
    debugger;
    this.isLoading = !this.isLoading;
    var id = this.client.id;
    this.client = this.clientForm.value;
    this.api.createClient(this.client, id).subscribe((res: any) => {
      //this.api.createClients({ client: this.client }, id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.clientForm.reset();
      this.getClients();
      if (this.files.length > 0) {
        this.uploadFile(res.data.id);
      }
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Client successfully updated! ' : 'Client  successfully added!', type: 'dark' });
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update client!' : 'Could not add client!', type: 'danger' });

    });

  }

  reset() {
    debugger;
    this.operation = 'add';
    this.clientForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getClients();
  }

  editClient(client: any) {
    debugger;
    this.operation = 'update';
    this.client = client;
    this.clientForm.get('trade_name').setValue(client.trade_name);
    this.clientForm.get('business_category').setValue(client.business_category);
    this.clientForm.get('registration_date').setValue(client.registration_date.split(" ")[0]);
    this.clientForm.get('tin_number').setValue(client.tin_number);
    this.clientForm.get('type').setValue(client.type);
    this.clientForm.get('status').setValue(client.status);
    this.clientForm.get('remark').setValue(client.remark);
    this.files = client.files.data.filter(
      (file: any) => file.designation.toLowerCase().indexOf('logo'.toLowerCase()) !== -1
    );

  }

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  onFilesAdded(files: any) {
    debugger;
    this.files = files.addedFiles;
    for (let file of this.files) {
      let fileName: any;
      fileName = file['name'];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.localUrl = event.target.result;
          this.compress(this.localUrl, fileName);
        }
        reader.readAsDataURL(file);
      }
    }

  }

  async compress(image: any, fileName: string) {
    console.log('compressing...');
    this.files_temp = await this.mainService.compressFile(image, fileName);
    debugger;
    console.log(this.files_temp);

  }

  public async uploadFile(id: any) {
    debugger;
    this.successUploadCount = 0;
    this.failedUploadCount = 0;
    /* for (let file of this.files) { */
    for (let file of this.files_temp) {
      console.log(file);
      const formData = new FormData();
      if (file instanceof File) {
        formData.append('file', file, file.name);
        formData.append('item_id', id);
        formData.append('designation', 'logo');
        this.uploading = true;
        await this.mainService.upload(formData).then((res: any) => {
          this.uploadResponse = res;
          console.log(res);
          if (this.uploadResponse.status !== 'progress' &&
            this.uploadResponse.status !== 'unhandeled event') {
            this.successUploadCount++;
            let temp = (this.successUploadCount / this.files.length) * 100;
            this.uploadResponse.message = temp.toString();
          }
        }, function (err) {
          debugger;
          this.failedUploadCount++;
        });
        if (this.successUploadCount > 0) {
          this.getClients();
          this.mainService.toast({ title: 'Success', body: 'Client logo successfully uploaded! ', type: 'dark' });
        }

      }
    }
  }
}
